import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <footer>
      <p>All rights reserved by Al Shadab Arnab</p>
    </footer>
  );
};

export default Footer;
